import FormattedMessage from 'I18n/components/FormattedMessage';
import withUsageTracking from '../hoc/withUsageTracking';
import { Button } from 'foundations-components/transitional/components/Button';
import { SettingsIcon } from 'foundations-assets';
import styled from 'styled-components';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TextWrapper = styled.span.withConfig({
  displayName: "EPSettingsButton__TextWrapper",
  componentId: "sc-1gx1kzw-0"
})(({
  theme
}) => ({
  fontSize: theme.typography['body-100'].fontSize,
  fontWeight: theme.typography['body-100'].fontWeight,
  marginLeft: `${theme.space[100]} !important`
}));
const EPSettingsButton = ({
  onClick,
  onTrackUsage,
  hideLabel
}) => {
  const showLabel = !hideLabel;
  function handleClick() {
    onClick();
    onTrackUsage('settings button click');
  }
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(Button, {
    "data-test-id": "ep-settings-button",
    paddingInline: "200",
    size: 'small',
    use: 'tertiary-light',
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx(IconHolder, {
      padding: "0",
      icon: SettingsIcon,
      size: "300"
      // detail-100 matches the font size on small buttons. Ideally we could
      // reference the Button component's size token helper in case the token
      // name changes, but it's a private util at the time of this writing
      // https://git.hubteam.com/HubSpot/foundations-components/blob/master/foundations-components/static-1.4933/js/transitional/components/Button/Button.helpers.ts#L423
      ,
      blockSize: theme.typography['detail-100'].lineHeight,
      alignItems: "center"
    }), showLabel && /*#__PURE__*/_jsx(TextWrapper, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "epSettingsButton.label"
      })
    })]
  });
};
export { EPSettingsButton };
export default withUsageTracking(EPSettingsButton);